import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { ScmHeader } from './Header';
import styles from './layout.module.less';
import { DocumentTitle } from '../components';
const { Content } = Layout;
export const ScmHeaderLayout = () => (_jsxs(Layout, { children: [_jsx(DocumentTitle, {}), _jsx(ScmHeader, {}), _jsx(Content, { className: styles['scm-header-layout-content'], children: _jsx(Outlet, {}) })] }));
